import { BaseProps } from "./BaseProps";
import "../../../styles/actionbar/item.css";

export { Link };
type Props = {
  href: string;
} & BaseProps;

const Link = (props: Props) => {
  return (
    <div
      className={`actionBarItem ${props.disabled ? "disabled" : ""}`}
      style={props.style}
    >
      <a href={props.href}>
        <span data-abi-title>{props.children}</span>
      </a>
    </div>
  );
};
